import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AdministratorService } from '@app/core/services/administrator/administrator.service';
import { PermissionEnum } from '@app/core/services/administrator/models/enum/permission.enum';
import { UserAdminUI } from '@app/core/services/administrator/models/user-admin.model';
import { Page } from '@app/core/services/commons/page';
import { InvoiceService } from '@app/core/services/invoice/invoice.service';
import { InvoiceMetaData } from '@app/core/services/invoice/models/invoice-meta-data.model';
import { SubscriptionDTO } from '@app/core/services/subscription/models/subscription/subscription.model';

@Component({
    selector: 'ap-invoices-panel',
    templateUrl: './invoices-panel.component.html',
    styleUrl: './invoices-panel.component.css',
    standalone: false
})
export class InvoicesPanelComponent implements OnInit {
  @Input() subscription: SubscriptionDTO;

  _invoices!: Page<InvoiceMetaData>;
  @Input()
  set invoices(value: Page<InvoiceMetaData>) {
    if (value && value.content) {
      this._invoices = value;
      this.invoicesDataSource.data = value?.content ?? [];
      this.totalElements = value?.totalElements ?? 0;
    } else {
      this._invoices = { content: [], totalElements: 0 } as Page<InvoiceMetaData>;
      this.invoicesDataSource.data = [];
      this.totalElements = 0;
    }
  };

  get invoices(): Page<InvoiceMetaData> {
    return this._invoices;
  };

  loggedAgent: UserAdminUI;
  Permissions = PermissionEnum;
  displayedColumns = ['REFERENCE', 'AMOUNT_TTC', 'START_DATETIME', 'END_DATETIME', 'STATUS', 'ACTIONS'];

  invoicesDataSource: MatTableDataSource<InvoiceMetaData> = new MatTableDataSource<InvoiceMetaData>();
  totalElements = 0;

  @ViewChild(MatPaginator) invoicePaginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private administratorService: AdministratorService, private invoiceService: InvoiceService) {}

  ngOnInit(): void {
    this.loggedAgent = this.administratorService.loggedAgent$.getValue();
    this.invoicesDataSource = new MatTableDataSource<InvoiceMetaData>(this.invoices?.content);
    this.totalElements = this.invoices.totalElements;
  }

  onInvoicePageChange($event: any) {
    this.loadInvoices();
  }

  onInvoiceSortChange($event: any) {
    this.invoicePaginator.pageIndex = 0;
    this.loadInvoices();
  }

  loadInvoices() {
    if (this.loggedAgent.roleInfos.permissions.includes(PermissionEnum.ACCESS_ALL_INVOICES)) {
      const pageIndex = this.invoicePaginator ? this.invoicePaginator.pageIndex : 0;
      const pageSize = this.invoicePaginator ? this.invoicePaginator.pageSize : 10;
      const sortField = this.sort?.active || 'dispatchDate';
      const sortDirection = this.sort?.direction || 'desc';

      this.invoiceService.getInvoiceData(this.subscription.subscriptionHolder.accountId, this.subscription.subscriptionId, sortDirection, sortField, pageIndex, pageSize).subscribe({
        next: _invoices => {
          this.invoices = _invoices;
        }
      });
    }
  }

  downloadInvoice(reference: string, serviceEmitter: string) {
    if (this.loggedAgent.roleInfos.permissions.includes(PermissionEnum.ACCESS_ALL_INVOICES)) {
      this.invoiceService.downloadInvoice(reference, serviceEmitter).subscribe(response => {
        const file = new Blob([response], {type: 'application/pdf'});
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        URL.revokeObjectURL(fileURL);
      });
    }
  }

}
